/* ChillyPup premium helpers (draft theme) */
(function(){
  'use strict';
  var EMO = /(?![©®™✓✔★])\p{Extended_Pictographic}️?|️|‍/gu;
  var EMO1 = /(?![©®™✓✔★])\p{Extended_Pictographic}|️/u;
  var SKIP = 'script,style,noscript,textarea,select,option,[class*=jdgm],[class*=localization],[class*=tl-switcher],.cp-keep';

  function stripEmoji(root){
    if (!root || !document.createTreeWalker) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) {
      var p = n.parentElement;
      if (!p || p.closest(SKIP)) continue;
      if (EMO1.test(n.nodeValue)) list.push(n);
    }
    list.forEach(function(t){
      var parent = t.parentElement;
      t.nodeValue = t.nodeValue.replace(EMO, '').replace(/[ \t]{2,}/g, ' ');
      if (parent && !parent.children.length && !parent.textContent.trim() && parent.tagName === 'SPAN') parent.style.display = 'none';
    });
  }

  function splitTitle(){
    document.querySelectorAll('.product__title h1').forEach(function(h){
      if (h.dataset.cpSplit) return;
      h.dataset.cpSplit = '1';
      var t = h.textContent.trim();
      var m = t.match(/^(.{10,}?)\s[–—-]\s(.+)$/);
      if (!m && t.length > 36) m = t.match(/^(.{10,}?),\s(.+)$/);
      if (!m) return;
      h.textContent = m[1];
      var s = document.createElement('span');
      s.className = 'cp-title-sub';
      s.textContent = m[2];
      h.appendChild(s);
    });
  }

  function basket(){
    if (!/^en/i.test(document.documentElement.lang || '')) return;
    if (window.variantStrings && /^add to cart$/i.test(window.variantStrings.addToCart || '')) window.variantStrings.addToCart = 'Add to basket';
    document.querySelectorAll('button[name=add] span, .quick-add__submit span').forEach(function(s){
      if (!s.children.length && /^\s*add to cart\s*$/i.test(s.textContent)) s.textContent = 'Add to basket';
    });
  }

  /* Adds a "Find the right fit" link (or a sizing help note) under the Size option.
     Skipped when the product is one size only, e.g. socks for people. */
  function fitGuide(){
    document.querySelectorAll('.product__info-container').forEach(function(info){
      if (info.querySelector('.cp-fit')) return;
      var inputs = [].slice.call(info.querySelectorAll('.product-form__input'));
      var sizeInput = inputs.filter(function(f){
        var l = f.querySelector('legend, .form__label');
        return l && /\bsize\b/i.test(l.textContent);
      })[0];
      if (!sizeInput) return;
      var choices = sizeInput.querySelectorAll('input[type=radio], option');
      if (choices.length <= 1 || /one size/i.test(sizeInput.textContent)) return;
      var anchor = sizeInput.closest('variant-selects, variant-radios') || sizeInput;
      var det = [].slice.call(info.querySelectorAll('details')).filter(function(d){
        var s = d.querySelector('summary');
        return s && /size|fit|measur/i.test(s.textContent);
      })[0];
      var wrap = document.createElement('div');
      wrap.className = 'cp-fit';
      if (det) {
        var acc = det.closest('.product__accordion') || det;
        if (!det.id) det.id = 'cp-size-' + Math.random().toString(36).slice(2, 8);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cp-fit__btn';
        b.textContent = 'Find the right fit';
        b.setAttribute('aria-controls', det.id);
        b.setAttribute('aria-expanded', det.open ? 'true' : 'false');
        b.addEventListener('click', function(){
          det.open = !det.open;
          if (det.open) { var s = det.querySelector('summary'); if (s) s.focus({ preventScroll: true }); }
        });
        det.addEventListener('toggle', function(){ b.setAttribute('aria-expanded', det.open ? 'true' : 'false'); });
        wrap.appendChild(b);
        wrap.appendChild(acc);
      } else {
        var p = document.createElement('p');
        p.className = 'cp-fit__note';
        p.innerHTML = 'Not sure on sizing? <a href="/pages/contact-us">Send us your dog’s measurements</a> and we will help you choose.';
        wrap.appendChild(p);
      }
      anchor.insertAdjacentElement('afterend', wrap);
    });
  }

  var timer;
  function runAll(){ splitTitle(); basket(); fitGuide(); }
  function init(){
    var main = document.getElementById('MainContent');
    stripEmoji(main);
    document.querySelectorAll('.announcement-bar, .footer, .section-header').forEach(stripEmoji);
    runAll();
    if (!window.MutationObserver || !main) return;
    new MutationObserver(function(muts){
      muts.forEach(function(m){ m.addedNodes.forEach(function(nd){ if (nd.nodeType === 1) stripEmoji(nd); }); });
      clearTimeout(timer);
      timer = setTimeout(runAll, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Scroll flow: content eases into view as you scroll, with gentle parallax on key photos.
   Applies to the ChillyPup sections on every page. Dawn sections already have their own reveal.
   Nothing moves for visitors who have reduced motion switched on. */
(function(){
  'use strict';
  if (window.__cpFlow) return; window.__cpFlow = true;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && Shopify.designMode) return;
  var GROUPS = [
    ['.cp-guides__head > *, .cp-tg__head > *, .cp-gallery__head > *, .cp-reviews__head > *, .cp-pair__head > *, .cp-sel__head > *', 0.08],
    ['.cp-guides__item, .cp-tg__item, .cp-gallery__item, .cp-pair__card, .cp-pair__plus, .cp-sel__grid > .cp-card, .cp-trust__item, .cp-cl__item', 0.07],
    ['.cp-story__content > *, .cp-guide__chapter > *, .cp-details__intro > *', 0.06],
    ['.cp-acc', 0.04],
    ['.cp-cl__feature, .cp-cl__grid-h, .cp-cl__chips, .cp-guides__note, .cp-gallery__foot, .cp-tg__closing, .cp-pair__offer, .cp-sel__foot, .cp-reviews__foot, .cp-story__visual', 0]
  ];
  function init(){
    var main = document.getElementById('MainContent') || document.body;
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    GROUPS.forEach(function(g){
      main.querySelectorAll(g[0]).forEach(function(el){
        if (el.closest('.scroll-trigger, .product__info-container, .cp-flow-skip')) return;
        var i = Array.prototype.indexOf.call(el.parentNode.children, el);
        el.classList.add('cp-rv');
        el.style.setProperty('--rv-d', Math.min(i * g[1], 0.5) + 's');
        io.observe(el);
      });
    });
    if (document.querySelector('[data-cp-noparallax]')) return;
    var px = [];
    main.querySelectorAll('.cp-hero__media img').forEach(function(el){ px.push({ el: el, box: el.parentNode, k: -0.06, s: 1.08 }); });
    main.querySelectorAll('.cp-story__media img').forEach(function(el){ px.push({ el: el, box: el.parentNode, k: -0.05, s: 1.1 }); });
    if (window.matchMedia('(min-width: 990px)').matches) {
      main.querySelectorAll('.cp-gallery__strip').forEach(function(strip){
        strip.querySelectorAll('.cp-gallery__fig').forEach(function(el, n){ px.push({ el: el, box: strip, k: (n % 2 ? -0.08 : 0.04), s: 1 }); });
      });
    }
    if (!px.length) return;
    px.forEach(function(p){ p.el.setAttribute('data-cp-px', ''); });
    var ticking = false;
    function run(){
      ticking = false;
      var vh = window.innerHeight;
      px.forEach(function(p){
        var r = p.box.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var y = (r.top + r.height / 2 - vh / 2) * p.k;
        p.el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)' + (p.s !== 1 ? ' scale(' + p.s + ')' : '');
      });
    }
    window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    window.addEventListener('resize', run);
    run();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Policy pages (shipping, returns, privacy, terms): rebuilt as a guide-style layout with a sticky
   "On this page" contents list, matching the dog owner's guide. The policy wording itself is untouched. */
(function(){
  'use strict';
  function init(){
    var box = document.querySelector('.shopify-policy__container');
    if (!box || box.dataset.cpPolicy) return;
    var body = box.querySelector('.shopify-policy__body .rte') || box.querySelector('.shopify-policy__body');
    if (!body) return;
    box.dataset.cpPolicy = '1';
    var path = location.pathname;
    var NAMES = { 'refund-policy': 'Returns and refunds', 'shipping-policy': 'Shipping information', 'privacy-policy': 'Privacy policy', 'terms-of-service': 'Terms of service', 'contact-information': 'Contact information', 'legal-notice': 'Legal notice', 'subscription-policy': 'Subscription policy' };
    var key = (path.match(/\/policies\/([^\/?#]+)/) || [])[1] || '';
    var titleEl = box.querySelector('.shopify-policy__title h1');
    var title = NAMES[key] || (titleEl ? titleEl.textContent.trim() : document.title);
    var updated = '';
    var heads = [];
    var n = 0;
    Array.prototype.slice.call(body.children).forEach(function(el){
      var tag = el.tagName, txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!txt) { if (tag === 'P') el.remove(); return; }
      if (/^last updated/i.test(txt) && txt.length < 60) { updated = txt.replace(/^last updated:?\s*/i, ''); el.remove(); return; }
      var isHead = /^H[1-4]$/.test(tag);
      if (!isHead && tag === 'P' && el.children.length === 1 && /^(STRONG|B)$/.test(el.children[0].tagName) && el.children[0].textContent.trim() === txt && txt.length < 90) isHead = true;
      if (!isHead) return;
      if (tag === 'H1' || (/chillypup/i.test(txt) && /(policy|terms|notices)/i.test(txt) && heads.length === 0)) { el.remove(); return; }
      var prev = el.previousElementSibling;
      if (prev && prev.classList && (prev.classList.contains('cp-pol__h') || prev.classList.contains('cp-pol__sub'))) {
        var sub = document.createElement('h3');
        sub.className = 'cp-pol__sub';
        sub.textContent = txt.replace(/:$/, '');
        el.replaceWith(sub);
        return;
      }
      var h = document.createElement('h2');
      h.className = 'cp-pol__h';
      h.textContent = txt.replace(/:$/, '');
      h.id = 'section-' + (++n);
      el.replaceWith(h);
      heads.push(h);
    });
    var others = [['shipping-policy','Shipping information'],['refund-policy','Returns and refunds'],['privacy-policy','Privacy policy'],['terms-of-service','Terms of service']];
    var wrap = document.createElement('div');
    wrap.className = 'cp-pol';
    var tocItems = heads.map(function(h, i){ return '<li><a href="#' + h.id + '"><span class="cp-pol__num">' + ('0' + (i + 1)).slice(-2) + '</span><span>' + h.textContent.replace(/[<>&]/g, '') + '</span></a></li>'; }).join('');
    var rel = others.filter(function(o){ return o[0] !== key; }).map(function(o){ return '<li><a class="cp-pol__chip" href="/policies/' + o[0] + '">' + o[1] + '</a></li>'; }).join('');
    wrap.innerHTML =
      '<header class="cp-pol__hero"><p class="cp-eyebrow">Help &amp; info</p><h1 class="cp-display cp-pol__title"></h1>' + (updated ? '<p class="cp-pol__updated">Last updated ' + updated.replace(/[<>&]/g, '') + '</p>' : '') + '</header>' +
      '<div class="cp-pol__grid">' +
        (heads.length > 1 ? '<aside class="cp-pol__side"><details class="cp-pol__toc" open><summary><span class="cp-eyebrow">On this page</span><span class="cp-acc__icon" aria-hidden="true"></span></summary><ol class="cp-pol__list" role="list">' + tocItems + '</ol></details>' +
        '<div class="cp-pol__help"><p class="cp-pol__help-title">Still have a question?</p><p>We’re a small, family-run team and always happy to help.</p><a class="cp-link" href="/pages/contact-us">Contact us</a></div></aside>' : '') +
        '<div class="cp-pol__body rte"></div>' +
      '</div>' +
      '<nav class="cp-pol__more" aria-label="Other policies"><p class="cp-eyebrow">More help &amp; info</p><ul role="list">' + rel + '</ul></nav>';
    wrap.querySelector('.cp-pol__title').textContent = title;
    var target = wrap.querySelector('.cp-pol__body');
    while (body.firstChild) target.appendChild(body.firstChild);
    box.innerHTML = '';
    box.appendChild(wrap);
    box.classList.add('cp-pol-ready');
    var toc = wrap.querySelector('.cp-pol__toc');
    if (toc && window.matchMedia('(max-width: 989px)').matches) toc.open = false;
    if (toc) toc.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ if (window.matchMedia('(max-width: 989px)').matches) toc.open = false; }); });
    if ('IntersectionObserver' in window && heads.length > 1) {
      var links = {};
      wrap.querySelectorAll('.cp-pol__list a').forEach(function(a){ links[a.getAttribute('href').slice(1)] = a; });
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (e.isIntersecting) {
            Object.keys(links).forEach(function(k){ links[k].classList.toggle('is-current', k === e.target.id); });
          }
        });
      }, { rootMargin: '-15% 0px -70% 0px' });
      heads.forEach(function(h){ io.observe(h); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
